import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Header from './components/Header/Header';
import Timeline from './components/Timeline/Timeline';
import SideProjects from './components/SideProjects/SideProjects';
import Footer from './components/Footer/Footer';
import './index.css';

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <div className="container mx-auto max-w-2xl px-4 py-8">
          <Header />
          <Timeline />
          <SideProjects />
          <Footer />
        </div>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;